if (!customElements.get('row-carousel')) {
  class RowCarousel extends HTMLElement {
    constructor() {
      super()

      this.isDragging = false
      this.startPosX = 0
      this.scrollLeftPosX = 0
      this.currentIndex = 0
      this.moving = false
      this.movingTimeout = ''
      this.percentage = 0

      this.adjustScrollWidth()
      this.checkStatus()
    }

    connectedCallback() {
      if (this.sliderElement) {
        this.sliderElement.addEventListener('scroll', this.onScroll.bind(this))
        this.sliderElement.addEventListener('mousedown', this.onMouseDown.bind(this))
        this.sliderElement.addEventListener('mouseup', this.onMouseUp.bind(this))
        this.carouselArrows.forEach(element => {
          element.addEventListener('click', this.onClickArrow.bind(this))
        })

        window.addEventListener('resize', (event) => {
          this.adjustScrollWidth()
        })
      }
    }

    disconnectedCallback() {
      if (this.sliderElement) {
        this.sliderElement.removeEventListener('scroll', this.onScroll.bind(this))
        this.sliderElement.removeEventListener('mousedown', this.onMouseDown.bind(this))
        this.sliderElement.removeEventListener('mouseup', this.onMouseDown.bind(this))
        this.carouselArrows.forEach(element => {
          element.removeEventListener('click', this.onClickArrow.bind(this))
        })
      }
    }

    onScroll (e) {
      clearTimeout(this.movingTimeout)
      this.movingTimeout = setTimeout(() => {
        if (!this.moving && this.isOutOfView() && this.percentage < 100) {
          this.moving = true
          this.moveToIndex(this.currentIndex, false)
          setTimeout(() => {
            this.moving = false
          }, 300);
        }
      }, 100)
      this.adjustScrollWidth()
    }

    onClickArrow (e) {
      const arrow = e.currentTarget
      const direction = arrow?.getAttribute('data-direction') || 'next'
      this.move(direction)
    }

    move (direction='next') {
      this.currentIndex = (direction == 'next') ?
        this.currentIndex + 1 :
        this.currentIndex - 1
      if (this.currentIndex < 0) this.currentIndex = 0
      if (this.currentIndex >= this.itemsCount) this.currentIndex = this.itemsCount - 1
      this.moveToIndex(this.currentIndex)
    }

    moveToIndex(index = 1, isDispatch = true, animation = true) {
      this.currentIndex = index
      const targetElement = this.querySelector(`.js-slider-item[data-index="${index}"]`)
      const style = getComputedStyle(targetElement)
      const offsetX = parseInt(style.marginLeft || '0px')

      if (isDispatch) this.dispatchEvent(
        new CustomEvent('CarouselChanged', {
          detail: {
            currentIndex: parseInt(index)
          },
        })
      )

      if (animation) {
        this.sliderElement.scrollTo({
          left: targetElement.offsetLeft - offsetX,
          behavior: 'smooth'
        })
      } else {
        this.sliderElement.scrollLeft = targetElement.offsetLeft - offsetX
      }
    }

    onMouseDown (e) {
      this.isDragging = true
      this.startPosX = e.clientX - this.sliderElement.offsetLeft
      this.scrollLeftPosX = this.sliderElement.scrollLeft
      this.sliderElement.style.cursor = 'grabbing'

      e.preventDefault()
    }

    onMouseUp (e) {
      if ((e.clientX - this.startPosX) > 0) {
        this.move('prev')
      } else if ((e.clientX - this.startPosX) < 0) {
        this.move('next')
      }

      this.isDragging = false
      this.sliderElement.style.cursor = 'grab'
      this.sliderElement.style.transition = 'scroll 0.3s ease-in-out'
    }

    adjustScrollWidth() {
      if (this.sliderElement) {
        this.percentage = (this.sliderElement.clientWidth + this.sliderElement.scrollLeft) * 100 / this.sliderElement.scrollWidth
        this.style.setProperty('--active-percentage', `${this.percentage}%`)
        this.updateIndex()

        if (this.sliderElement.scrollWidth == this.sliderElement.clientWidth) {
          this.classList.add('hide-nav')
        } else {
          this.classList.remove('hide-nav')
        }
      }
    }

    updateIndex() {
      this.querySelectorAll('.js-slider-item').forEach(item => {
        const style = getComputedStyle(item)
        const offsetX = parseInt(style.marginLeft || '0px')
        const cardHalfWidth = (item.clientWidth || 0) / 2
        const itemPos = item.offsetLeft - offsetX

        if (
          (this.sliderElement.scrollLeft - cardHalfWidth) < itemPos &&
          (this.sliderElement.scrollLeft + cardHalfWidth) > itemPos
        ) {
          this.currentIndex = parseInt(item.getAttribute('data-index') || '0')
        }
      })
    }

    isOutOfView() {
      const targetElement = this.querySelector(`.js-slider-item[data-index="${this.currentIndex}"]`)
      const style = getComputedStyle(targetElement)
      const offsetX = parseInt(style.marginLeft || '0px')

      const elementLeft = targetElement.offsetLeft - offsetX
      this.scrollLeftPosX = this.sliderElement.scrollLeft
      return this.scrollLeftPosX != elementLeft
    }

    checkStatus () {
      if (this.itemsCount > 1) {
        this.classList.add('show-status-mobile')
        this.classList.add('show-nav')
      }

      if (this.itemsCount > 3) {
        this.classList.add('show-status-desktop')
        this.classList.add('show-nav')
      }
    }

    get sliderElement() {
      return this.querySelector('.js-slider')
    }

    get carouselArrows() {
      return this.querySelectorAll('.js-slider-arrow')
    }

    get itemsCount() {
      return this.querySelectorAll('.js-slider-item').length || 0
    }
  }

  customElements.define('row-carousel', RowCarousel)
}